var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrears(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.200195 0.200195V2.3578V13.15V21.7834H2.3584V13.15H6.6754H7.7542H17.4664L15.3082 7.75419L17.4664 2.3578H8.8336H7.7542H2.3584V0.200195H0.200195ZM2.3584 4.5172H7.7542H8.8336H14.2834L13.3126 6.9556L12.9886 7.7542L13.3012 8.5528L14.2726 10.9924H7.7542H6.6754H2.3584V4.5172Z",
    fill: "#202428"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrears);
export default __webpack_public_path__ + "static/media/Arrears.1febfb2386e43ef5ecb8daeca2273261.svg";
export { ForwardRef as ReactComponent };